import React from "react";
import { SecurityResponse } from "@quest-finance/quest-fe-shared/dist/application/types/SecurityResponse";
import { resolveAssetLabels } from "../../utils/security";
import "./SecurityData.scss";

interface AdditionalSecurityRowProps {
  security: SecurityResponse;
  assetIndex: number;
}

const AdditionalSecurityRow: React.FunctionComponent<
  AdditionalSecurityRowProps
> = ({ security, assetIndex }) => {
  const { assetCategoryLabel, assetTypeLabel, usageTypeLabel } =
    resolveAssetLabels(security);

  const yearMakeModel = [
    security.manufactureYear,
    security.make,
    security.model,
  ]
    .filter(Boolean)
    .join(" ");

  const summary = [
    usageTypeLabel,
    assetCategoryLabel,
    assetTypeLabel,
    yearMakeModel,
    security.description,
  ]
    .filter(Boolean)
    .join(" - ");

  return (
    <div
      className="additional-security-row"
      data-testid={`additional-security-row-${assetIndex}`}
    >
      <h6 className="section-header">Security - Asset {assetIndex}</h6>
      <div
        className="additional-security-summary"
        data-testid={`additional-security-summary-${assetIndex}`}
      >
        {summary}
      </div>
    </div>
  );
};

export default AdditionalSecurityRow;
